import Skeleton from "react-loading-skeleton";
import styles from "./skeleton.module.scss";

const CustomSkeleton = ({
  height,
  width,
}: {
  height: string;
  width: string;
}) => {
  return (
    <div
      className={styles.skeleton}
      style={{ maxWidth: width, height: height }}
    >
      <Skeleton height={height} width={width} />
    </div>
  );
};

export default CustomSkeleton;
